import { mergeStyleSets } from "@fluentui/react";

export const useStyles = () => mergeStyleSets({
  dialogContext: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '340px',
    minWidth: '288px',
    maxHeight: '340px',
    minHeight: '172px',
    padding: '24px',
  },
  content: {
    display: 'flex',
  }
})
